import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.APPROVED_REJECTED_BRAND_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.APPROVED_REJECTED_BRAND_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.APPROVED_REJECTED_BRAND_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.APPROVED_REJECTED_BRAND_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.APPROVED_REJECTED_BRAND_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
